{
  "title": "Календар",
  "description": "Заплановані уроки, тиждень за тижнем.",
  "classFilter": "Клас",
  "allClasses": "Усі класи",
  "previousWeek": "Попередній тиждень",
  "nextWeek": "Наступний тиждень",
  "thisWeek": "Цей тиждень",
  "minutes_one": "{{count}} хв",
  "minutes_few": "{{count}} хв",
  "minutes_many": "{{count}} хв",
  "minutes_other": "{{count}} хв",
  "empty": {
    "title": "Цього тижня нічого не заплановано",
    "staffText": "Заплануйте урок на його власній сторінці — і він з’явиться в цьому розкладі.",
    "readerText": "Тут з’являються уроки, які вчителі планують для ваших класів.",
    "action": "До курсів",
    "filterTitle": "Цього тижня для цього класу нічого немає",
    "filterText": "Цього тижня уроки є, але для обраного класу — жодного.",
    "clearFilter": "Показати всі класи"
  },
  "upcoming": {
    "title": "Найближчі уроки",
    "openCalendar": "Відкрити календар",
    "empty": "На найближчі 7 днів уроків не заплановано."
  },
  "reschedule": {
    "button": "Перенести",
    "title": "Перенести урок",
    "description": "{{lesson}} — {{class}}. Оберіть новий час або тривалість.",
    "startsAt": "Початок",
    "duration": "Тривалість (хвилин)",
    "submit": "Зберегти",
    "success": "Урок перенесено"
  },
  "unschedule": {
    "button": "Прибрати з календаря",
    "title": "Прибрати «{{lesson}}» з календаря?",
    "description": "Сам урок залишиться — буде прибрано лише цей запис у календарі.",
    "success": "Урок прибрано з календаря"
  }
}
